import {useEffect, useRef, useState} from "react";
import {useNavigate, useParams} from "react-router-dom";
import {getInternationalProduct, getRecommendations} from "../../actions/ApiCalls";
import Header from "../Header/Header";
import ProductFilter from "../ProductFilter";
import Footer from "../Footer/Footer";
import {IMAGE_URL} from "../../path";

function InternationalProduct() {
    const {brand, product} = useParams<{ brand?: string, product?: string; }>();

    const [productInfo, setProductInfo] = useState<any>(null);
    const [recommendedProducts, setRecommendedProducts] = useState<any[]>([]);
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    const [imageMaxWidth, setImageMaxWidth] = useState("220px");
    const mainImageRef = useRef<HTMLImageElement>(null);


    const navigate = useNavigate();

    const handleImageClick = (productSearchName: string) => {
        if (brand) {
            window.scrollTo({ top: 0, behavior: 'smooth' }); // Scroll to top
            navigate(`/our-wines/${brand}/${productSearchName}`);
        }
    };

    const [filterMode, setFilterMode] = useState<'hidden' | 'scroll' | 'fixed'>('hidden');
    const filterRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setFilterMode('scroll');
                } else {
                    setFilterMode('fixed');
                }
            },
            { threshold: 0.1 }
        );

        if (filterRef.current) {
            observer.observe(filterRef.current);
        }

        return () => {
            if (filterRef.current) {
                observer.unobserve(filterRef.current);
            }
        };
    }, []);

    useEffect(() => {
        window.scrollTo(0, 0);
        fetchProductInfo();
        fetchRecommendedProducts();

        const handleResize = () => setWindowWidth(window.innerWidth);
        window.addEventListener("resize", handleResize);

        return () => window.removeEventListener("resize", handleResize);
    }, [brand, product]);

    useEffect(() => {
        const img = mainImageRef.current;
        if (!img) return;

        const handleLoad = () => {
            const aspectRatio = img.naturalHeight / img.naturalWidth  ;

            if (window.innerWidth < 576) {
                setImageMaxWidth("250px"); // Always cap at 250px on mobile
            } else {
                setImageMaxWidth(aspectRatio < 1.5 ? "450px" : "220px");
            }
        };

        if (img.complete) {
            handleLoad();
        } else {
            img.addEventListener("load", handleLoad);
            return () => img.removeEventListener("load", handleLoad);
        }
    }, [productInfo?.image_path, windowWidth]);

    function fetchProductInfo() {
        if (product) {
            getInternationalProduct(product)
                .then(response => setProductInfo(response.data.data))
                .catch(error => console.error("Failed to fetch product info:", error));
        }
    }

    function fetchRecommendedProducts() {
        if (product && brand) {
            getRecommendations(brand, product)
                .then(response => setRecommendedProducts(response.data))
                .catch(error => console.error("Failed to fetch recommended products:", error));
        }
    }

    const wineURL = IMAGE_URL;

    return (
        <div style={{
            minHeight: '100vh',
            display: 'flex',
            flexDirection: 'column',
            position: 'relative',
            width: '100%',
            // overflow: 'hidden'
        }}>

            <Header />
            <div style={{ marginTop: '70px' }}>
                <div
                    style={{
                        display: 'flex',
                        flexDirection: windowWidth > 576 ? 'row' : 'column',
                        gap: '20px',
                        padding: '20px',
                        marginBottom: '100px',
                    }}
                >
                    <div
                        style={{
                            flex: 1,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                        }}
                    >
                        <img
                            ref={mainImageRef}
                            src={`${wineURL}${productInfo?.image}`}
                            alt={productInfo?.name}
                            style={{
                                maxWidth: imageMaxWidth,
                                width: '100%',
                                height: 'auto',
                                objectFit: 'contain',
                                display: 'block',
                                maxHeight: windowWidth > 576 ? '85vh' : '70vh',
                            }}
                        />
                    </div>


                    <div
                        style={{
                            flex: 1,
                            textAlign: "left",
                            padding: windowWidth > 576 ? '0 20px' : '20px',
                            marginTop: windowWidth > 576 ? '140px' : '0',
                            marginLeft: windowWidth > 576 ? '26px' : '0',
                        }}
                    >
                        {productInfo?.brand && windowWidth > 576 && (
                            <img
                                src={`${wineURL}${productInfo.brand.color_logo}`}
                                alt={productInfo.brand.name}
                                style={{ width: '170px', cursor: 'pointer' }}
                                onClick={() => navigate(`/our-wines/international/${productInfo?.brand?.search_name}`)}
                            />
                        )}

                        <p style={{
                            fontWeight: 600,
                            textTransform: 'uppercase',
                            marginBottom: 0,
                            marginTop: windowWidth > 576 ? '50px' : '0'
                        }}>
                            {productInfo?.name}
                        </p>
                        <p style={{
                            fontWeight: 600,
                            textTransform: 'uppercase',
                            marginTop: 0
                        }}>
                            {productInfo?.year}
                        </p>
                        <p style={{
                            width: windowWidth > 576 ? '70%' : '100%',
                            marginBottom: '20px',
                            marginTop: '20px'
                        }}>
                            {productInfo?.description}
                        </p>

                        <div style={{ display: 'flex', gap: '20px', marginTop: '20px' }}>
                            <a
                                href={`${wineURL}${productInfo?.tasting_notes}`}
                                className="brand-link"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                tasting note
                            </a>
                            <a
                                className="brand-link"
                                href={`${wineURL}${productInfo?.hd_image}`}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                Hi-res image
                            </a>
                        </div>
                    </div>
                </div>



            </div>
            <Footer />
        </div>
    );
}

export default InternationalProduct;
